export const CATEGORIES = {
    'Body Area': [
        {
            name: 'Abdomen',
            subcategories: [],
        },
        {
            name: 'Head and Neck',
            subcategories: ['Skull & Head', 'Neck'],
        },
        {
            name: 'Lower Limb',
            subcategories: ['Hip & Pelvis', 'Knee', 'Lower Limb', 'Foot & Ankle'],
        },
        {
            name: 'Thorax',
            subcategories: ['Chest', 'Spine & Back'],
        },
        {
            name: 'Upper Limb',
            subcategories: ['Shoulder', 'Upper Arm', 'Elbow & Forearm', 'Hand & Wrist'],
        },
    ],
    Cardiorespiratory: [],
    'Chronic conditions': [],
    'General principles': [],
    'Medical conditions': [],
    Musculoskeletal: [],
    Neurology: [],
    Paediatrics: [],
    Rheumatology: [],
    "Women's health": [],
    Diagrams: [],
};
